// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  selectCartUUID,
  selectOneProduct,
  selectProductsByType,
} from '@gandi/cart';

import { withTranslator } from '@gandi/translate';

import { getFormValues } from 'gandi.react-form';

import { withRouter } from 'src/helpers/withRouter';

import { serversResource } from '../../modules/cloud/resources/servers';
import type { FullState, WithRouterProps } from '../../types';

import { withAccount } from '../modules/account';

import { selectFetchServersParams, withServers } from '../modules/servers';

import Presenter, {
  type PresenterInjectedProps,
  type PresenterStateProps,
} from './Presenter';

const selectFormValues = getFormValues('cloud-create-server');

const cloudProductType = { productType: 'cloud' };

const mapStateToProps = (
  state: FullState,
  ownProps: PresenterInjectedProps & WithRouterProps<{ productId: string }>,
): PresenterStateProps => {
  const formValues = selectFormValues(state) || {};

  const fetchServersParams = selectFetchServersParams(state);
  const label = serversResource.computeLabel(
    serversResource.options.fetchPath,
    // $FlowFixMe[incompatible-call]
    fetchServersParams,
  );
  const totalCount = serversResource.selectTotalCount(state, label);

  return {
    cartId: selectCartUUID(state),
    cloudProducts: selectProductsByType(state, cloudProductType),
    formValues,
    isFirstServer:
      // $FlowFixMe[sketchy-number-and]
      totalCount && ownProps.account?.balance
        ? !(totalCount > 0 || ownProps.account.balance.price_after_taxes !== 0)
        : true,
    product: selectOneProduct(state, { productId: ownProps.params.productId }),
  };
};

export default (compose(
  withRouter,
  withTranslator({ propsNamespace: 'translator' }),
  withAccount,
  withServers,
  connect(mapStateToProps),
)(Presenter): React.ComponentType<{}>);
